import { Attributes, Tag } from 'sanitize-html';

import { pathWithBasename } from 'utils/pathWithBasename';

export const dataLinkedConversationIdAttribute = 'data-linked-conversation-id';

/** Creates a linked conversations internal note */
export function createLinkInternalNote(text: string, csids: number[]): string {
  const trimmedText = text.trim();
  return `${trimmedText ? trimmedText + '\n' : ''}Linked Conversations\n${csids
    .map(
      (csid) =>
        `<span ${dataLinkedConversationIdAttribute}="${csid}">#${csid}</span>`,
    )
    .join(' ')}`;
}

export function transformConversationLinkElement(
  tagName: string,
  attribs: Attributes,
): Tag {
  const csid = attribs[dataLinkedConversationIdAttribute];
  return csid
    ? {
        tagName: 'a',
        attribs: {
          class: 'message-conversation-link',
          href: `${window.location.origin}${pathWithBasename(
            `/conversation/${csid}`,
          )}`,
          target: '_blank',
          rel: 'noopener noreferrer',
          tabindex: '-1',
        },
        text: `#${csid}`,
      }
    : { tagName, attribs };
}
